import React from "react";
import { useLabels } from "../../../hooks/useLabels";
import { showLoginDialogAsync } from "../login-dialog";
import { labels } from "./labels";

import "./events-dialog-login.css";
import { useEditor } from "../../../hooks/useEditor";
import { useErrorHandling } from "../../../hooks/useErrorHandling";
import { useUserEventsActions } from "../../../hooks/useUserEvents";
import { Button } from "../../button";

export const EventsDialogLogin = () => {
	const { invalidateCacheAsync } = useUserEventsActions();
	const editor = useEditor();
	const { createErrorHandler } = useErrorHandling();

	const [[softLoginText, signInText], areLabelsLoading] = useLabels([
		labels.softLogin,
		labels.signIn,
	]);

	const onSignInClicked = () => {
		showLoginDialogAsync(undefined, { editor })
			.then((result) => {
				if (result) {
					invalidateCacheAsync().catch(createErrorHandler());
				}
			})
			.catch(createErrorHandler());
	};

	if (areLabelsLoading) return null;

	return (
		<div className="events-dialog-login">
			<div
				dangerouslySetInnerHTML={{ __html: softLoginText }}
				className="events-dialog-login__content"
			/>
			<Button primaryColor compact onClick={() => onSignInClicked()}>
				{signInText}
			</Button>
		</div>
	);
};
